const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

export default styles;


// WEBPACK FOOTER //
// ./src/main/components/styles/NavBarStyles.js